define('common/shuffle',[
],
    function () {

        var Shuffle = window.Shuffle;

        function init(selector, itemSelector) {
            var element = document.querySelector(selector);
            var shuffleInstance = new Shuffle(element, {
                itemSelector: itemSelector,
                speed: 250
            });
            window.addEventListener("resize", function () {
                setEqualHeightForShuffleItems(shuffleInstance);
                shuffleInstance.update();
            });
            return shuffleInstance;
        }

        function changeContent(shuffleInstance, html, displayCount) {
          if (html !== "NO_HTML") {
            var newElements = $($.parseHTML(html)).filter(shuffleInstance.options.itemSelector).toArray();
            var currentElements = shuffleInstance.items.map(function (i) { return i.element; });

            if (currentElements.length) {
                shuffleInstance.remove(currentElements);
            }

            if (newElements.length) {
                newElements.forEach(function (element) {
                    shuffleInstance.element.appendChild(element);
                });
                shuffleInstance.add(newElements);
            }
          }

            sort(shuffleInstance);
            filter(shuffleInstance, displayCount);
            setEqualHeightForShuffleItems(shuffleInstance);
            shuffleInstance.update();
        }

        function sort(shuffleInstance) {
            shuffleInstance.sort({
                by: function (element) {
                    return Number(element.getAttribute("data-sort"));
                }
            });
        }

        function filter(shuffleInstance, displayCount) {
            shuffleInstance.filter(function (element) {
                return Number(element.getAttribute("data-sort") <= displayCount);
            });
        }

        function setEqualHeightForShuffleItems(shuffleInstance) {
            // get elements from shuffle items
            var elements = shuffleInstance.items.map(function (i) { return i.element; });
            if (elements.length) {
                //puts the height of all elements in an array
                var heights = elements.map(function (element) { return $(element).children().prop("scrollHeight"); });
                //gets the highest value out of the array
                var maxHeight = heights.reduce(function (a, b) { return Math.max(a, b); });
                //sets height of all the elements to be the same as the highest one
                elements.forEach(function (element) { $(element).height(maxHeight); });
            }
        }

        return {
            init: init,
            changeContent: changeContent,
            filter: filter
        };
    });

